import { render, staticRenderFns } from "./AnredenOverview.vue?vue&type=template&id=2b846525&scoped=true"
import script from "./AnredenOverview.vue?vue&type=script&lang=js"
export * from "./AnredenOverview.vue?vue&type=script&lang=js"
import style0 from "./AnredenOverview.vue?vue&type=style&index=0&id=2b846525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b846525",
  null
  
)

export default component.exports